function get_vh() {
    let announcement = document.querySelector('#announcement'),
        minus = 0,
        vh
    if(announcement) minus+=announcement.offsetHeight
    vh = (window.innerHeight - minus) * 0.01

    return vh
}


document.documentElement.style.setProperty('--vh', get_vh() + 'px');

window.addEventListener('resize', () => {
    document.documentElement.style.setProperty('--vh', get_vh() + 'px');
});
window.addEventListener('load', () => {
    document.documentElement.style.setProperty('--vh', get_vh() + 'px');
});
